export type URLStripper = {
  /**
   * Strips the specified parameter from the URL and returns its value.
   * @param name The name of the parameter to strip.
   * @returns The value of the stripped parameter, or undefined if it was not present.
   */
  stripParam: (name: string) => string | undefined

  /**
   * Returns the updated URL as a string after parameters have been stripped.
   * @returns The updated URL string.
   */
  toString: () => string
}

/**
 * This is a utility to help read and remove parameters from a URL.
 * @param originalUrl The original URL.
 * @returns An object with methods to strip parameters and get the updated URL as a string.
 */
export const createUrlStripper = (originalUrl: string): URLStripper => {
  const url = new URL(originalUrl)
  return {
    stripParam: (name: string) => {
      const value = url.searchParams.get(name)
      url.searchParams.delete(name)
      return value ?? undefined
    },
    toString: () => url.toString(),
  }
}
